import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** True while the OS asks for reduced motion. */
export function usePrefersReducedMotion(): boolean {
    const [reduced, setReduced] = useState(() => window.matchMedia(QUERY).matches);
    useEffect(() => {
        const query = window.matchMedia(QUERY);
        const handleChange = (): void => setReduced(query.matches);
        query.addEventListener('change', handleChange);
        return () => query.removeEventListener('change', handleChange);
    }, []);
    return reduced;
}
